import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function FeaturedSection() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            <strong>推荐</strong>漫画
          </h2>
          <p className="text-sm text-foreground-500">编辑精选，品质保证</p>
        </div>
        <Link
          to="/category/kehuan-manhua"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看全部
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </div>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5" data-product-shop>
        {featuredComics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}